function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M11.467 18.934v0A7.467 7.467 0 014 11.467v0A7.467 7.467 0 0111.467 4v0a7.467 7.467 0 017.467 7.467v0a7.467 7.467 0 01-7.467 7.467z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.467 12.504v-.207c0-.678.42-1.045.84-1.327.41-.276.82-.636.82-1.3a1.659 1.659 0 00-3.319-.001M11.466 14.843a.148.148 0 00-.149.15.15.15 0 10.149-.15M20 20l-3.25-3.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgConsultFaqs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgConsultFaqs;